import styled from 'styled-components';

export const MoreMethodsLink = styled.li`
	align-items: center;
	border-bottom: 1px solid var(--new-qd--list-border-color);
	color: rgba(var(--font-light), 1);
	display: flex;
	justify-content: space-between;
	padding: 8px 0;
	width: 100%;

	svg {
		color: rgba(var(--qd-modal-contrast-text), 1);
	}
`;

export const NewQDMethodsCollapseListWrapper = styled.ul`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	margin: 0;
	width: 100%;
`;
